import { useContext } from 'react';
import { themeContext } from './themeContext';
/**
 * Hook that returns a function which turns dark mode off and on
 */
export const useThemeData = () => {
    const ctx = useContext(themeContext);
    if (!ctx) {
        throw new Error('This must be done inside an `@msrceng/theme` ThemeProvider (not the fabric one)');
    }
    return ctx;
};
